import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface TrustLineProps {
  items: string[];
}
const SHIELD_PREFIX = '🛡️';
export function TrustLine({
  items
}: TrustLineProps) {
  return <p className="mt-2 text-center font-display text-xs font-semibold uppercase tracking-wide text-steel sm:text-sm" data-id="element-195" data-mp="3kwbp3nvu3gxi">
      {items.map((item, i) => {
      const hasShield = item.startsWith(SHIELD_PREFIX);
      const label = hasShield ? item.slice(SHIELD_PREFIX.length).trim() : item;
      return <React.Fragment key={item} data-id="element-196" data-mp="cgrzcyudggn7" data-mpi={i}>
            {i > 0 && <span className="mx-1.5 text-metal" data-id="element-197" data-mp="cj4r23pxm5dg">|</span>}
            {hasShield && <ShieldCheckIcon className="mr-1 inline-block h-[1.1em] w-[1.1em] -translate-y-px align-middle text-tech" aria-hidden="true" data-id="element-198" data-mp="7oh0lzbdb0w8" />}
            {label}
          </React.Fragment>;
    })}
    </p>;
}